import {Component} from 'react';
import withQueryStringProps from '../../components/withQueryStringProps';

@withQueryStringProps(['print'])
class ShowIfPrint extends Component {
  render() {
    if (this.props.print) {
      return this.props.children;
    } else {
      return null;
    }
  }
}

export default ShowIfPrint;



// WEBPACK FOOTER //
// ./src/components/ShowIfPrint/ShowIfPrint.js